import { autoinject } from "aurelia-dependency-injection";
import { FeatureFlagsModel } from "../../models/basic.models";
import { RequestClientService } from "./request-client.service";
import { ConfigService } from "./config.service";

@autoinject()
export class SystemSettingsService {
    private _featureFlags: FeatureFlagsModel;
    private static readonly FEATURE_FLAGS_ENDPOINT = "/api/v1/Settings/FeatureFlag";

    constructor(private requestClientService: RequestClientService, private configService: ConfigService) {
        // Initialize feature flags to null
        this._featureFlags = null;

    }

    async getFeatureFlags(): Promise<FeatureFlagsModel> {
        if (!this._featureFlags) {
            this._featureFlags = await this.requestClientService.get<FeatureFlagsModel>(this.configService.config.urls.rightShipPlatformApiUrl + SystemSettingsService.FEATURE_FLAGS_ENDPOINT, {});
        }
        return this._featureFlags;
    }

}